import {Entity} from '../../../components/entity';

export class ProductParameterFormat extends Entity {
  name: string;

  constructor({ id,
                name,
                createdAt, updatedAt }: Partial<ProductParameterFormat>) {
    super({ id, createdAt, updatedAt });
    this.name = name ?? '';
  }

  getNameProperty(): string {
    return 'name';
  }
}
